import axios from "axios";

export const config = {
    baseURL: "https://prod.educon.uz/api/v1",
    timeout: 300_000,
};

const request = axios.create(config);

export { request };
